export const NODE_ENV = process.env.REACT_APP_NODE_ENV || "dev";
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "/api";

export const STRIPE_PUBLISH_KEY = process.env.REACT_APP_STRIPE_PUBLISH_KEY;

export const STRIPE_PRO_MONTHLY = process.env.REACT_APP_STRIPE_PRO_MONTHLY;
export const STRIPE_PRO_ANNUAL = process.env.REACT_APP_STRIPE_PRO_ANNUAL;
export const STRIPE_PLUS_MONTHLY = process.env.REACT_APP_STRIPE_PLUS_MONTHLY;
export const STRIPE_PLUS_ANNUAL = process.env.REACT_APP_STRIPE_PLUS_ANNUAL;

// AI Generation Credits subscription plans
export const STRIPE_BASIC_MONTHLY = process.env.REACT_APP_STRIPE_BASIC_MONTHLY;
export const STRIPE_BASIC_ANNUAL = process.env.REACT_APP_STRIPE_BASIC_ANNUAL;
export const STRIPE_GROWTH_MONTHLY = process.env.REACT_APP_STRIPE_GROWTH_MONTHLY;
export const STRIPE_GROWTH_ANNUAL = process.env.REACT_APP_STRIPE_GROWTH_ANNUAL;
export const STRIPE_PRO_AI_MONTHLY = process.env.REACT_APP_STRIPE_PRO_AI_MONTHLY;
export const STRIPE_PRO_AI_ANNUAL = process.env.REACT_APP_STRIPE_PRO_AI_ANNUAL;

export const GODADDY_API_KEY = process.env.REACT_APP_GODADDY_API_KEY;
export const GODADDY_API_SECRET = process.env.REACT_APP_GODADDY_API_SECRET;

export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

export const CHECKOUT_URL = process.env.REACT_APP_CHECKOUT_URL || "https://sparkle.store";